import React, { useRef } from 'react'
import { Link } from 'react-router-dom';
import './footer.scss'
import FooterVideo from '../../Assets/Footer.mp4'
import { FiChevronRight, FiSend } from 'react-icons/fi'
// import { MdOutlineTravelExplore } from 'react-icons/md'
import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter } from 'react-icons/ai'
import { FaTripadvisor } from 'react-icons/fa'
import emailjs from '@emailjs/browser'
import Logo from '../../Assets/Logo.png'

const Footer = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            "service_a0f6obr",   //  EmailJS Service ID
            "template_0hv31k9",  // EmailJS Template ID
            form.current,
            "pLd3QhrFmeSifW3Ka"    //EmailJS Public Key
        )
            .then(
                (result) => {
                    alert("Email sent successfully!");
                },
                (error) => {
                    alert("Error sending email. Please try again.");
                }
            );
    }

    return (
        <section className="footer">
            <div className="videoDiv">
                <video src={FooterVideo} loop autoPlay muted type="video/mp4"></video>
            </div>

            <div className="secContent container">
                <div className="contactDiv flex">
                    <div className="text">
                        <small>KEEP IN TOUCH</small>
                        <h2> Travel With Us</h2>
                    </div>
                    {/* Email form */}
                    <form ref={form} onSubmit={sendEmail} className="inputDiv flex">
                        <input type="email" name="user_email" placeholder='Enter Email Address' required />
                        <button className='btn flex ' type='submit'>
                            SEND <FiSend className='icon' />
                        </button>
                    </form>
                </div>

                <div className="footerCard flex">
                    <div className="footerIntro flex">
                        <div className="logoDiv">
                            <a href='' className='logo flex'>
                                World Adventures Tours
                            </a>
                        </div>
                        <div className="footerParagraph">
                            Explore the world with World Adventures Tours. Your gateway to breathtaking destinations, thrilling treks, and unforgettable journeys. Discover new paths and create memories that last a lifetime.
                        </div>

                        <div className="footerSocials flex">
                            <AiOutlineTwitter className='icon' />
                            <AiFillYoutube className='icon' />
                            <AiFillInstagram className='icon' />
                            <FaTripadvisor className='icon' />
                        </div>
                    </div>

                    <div className="footerLinks grid">
                        {/* first part */}
                        <div className="linkGroup">
                            <span className=' groupTitle'>
                                Tours
                            </span>

                            <li className="footerList" >
                                <Link to="/mohenjo-daro-tours" className="flex">
                                    <FiChevronRight className='icon' />
                                    MohenjoDaro
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/lahore-heritage-tours" className="flex">
                                    <FiChevronRight className='icon' />
                                    Lahore City
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/multan-city-tours" className="flex">
                                    <FiChevronRight className='icon' />
                                    Multan City
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/hunza-valley-tours" className="flex">
                                    <FiChevronRight className='icon' />
                                    Hunza Valley
                                </Link>
                            </li>

                            <li className="footerList">
                                <Link to="taxila-tours" className="flex">
                                    <FiChevronRight className="icon" />
                                    Taxila Tours
                                </Link>
                            </li>
                        </div>

                        {/* second part */}
                        <div className="linkGroup">
                            <span className=' groupTitle'>
                                Expeditions
                            </span>

                            <li className="footerList" >
                                <Link to="/k2-expedition" className="flex">
                                    <FiChevronRight className='icon' />
                                    K2
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/nangaparbat-expedition" className="flex">
                                    <FiChevronRight className='icon' />
                                    NangaParbat
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/broad-peak-expedition" className="flex">
                                    <FiChevronRight className='icon' />
                                    BroadPeak
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/laila-peak-expedition" className="flex">
                                    <FiChevronRight className='icon' />
                                    LailaPeak
                                </Link>
                            </li>

                            <li className="footerList">
                                <Link to="/trango-tower-expedition" className="flex">
                                    <FiChevronRight className="icon" />
                                    Trango Tower
                                </Link>
                            </li>
                        </div>

                        {/* third part */}
                        <div className="linkGroup">
                            <span className=' groupTitle'>
                                Treks
                            </span>

                            <li className="footerList" >
                                <Link to="/k2-base-camp-trek" className="flex">
                                    <FiChevronRight className='icon' />
                                    K2 Base Camp
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/biafo-hispar-trek" className="flex">
                                    <FiChevronRight className='icon' />
                                    Biafo Hispar Trek
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/fairy-meadows-trek" className="flex">
                                    <FiChevronRight className='icon' />
                                    Fairy Meadows
                                </Link>
                            </li>

                            <li className="footerList flex">
                                <Link to="/rush-lake-trek" className="flex">
                                    <FiChevronRight className='icon' />
                                    Rush Lake Trek
                                </Link>
                            </li>

                            <li className="footerList">
                                <Link to="/nagma-valley-trek" className="flex">
                                    <FiChevronRight className="icon" />
                                    Nagma Valley
                                </Link>
                            </li>
                        </div>

                    </div>

                    <div className="footerDiv flex">
                        <small>BEST TOUR OPERATOR IN PAKISTAN</small>
                        <small>
                            © {new Date().getFullYear()} WorldAdventuresTours.com — All Rights Reserved
                        </small>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Footer
